import styled, { css } from "styled-components";
import { CssRule } from "../../../../themes/architecture/css-helpers/css-rule";

export const LinkToOfferBoxBase = styled.div<{shouldAnimate: boolean, hasCircle: boolean, isHybridEmbedded: boolean, isBottomNavBarEnabled?: boolean}>`
    background-size: contain;
    height: 50px;
    width: 50px;
    position: fixed;
    bottom: ${props => props.isHybridEmbedded || props.isBottomNavBarEnabled? 'calc(env(safe-area-inset-bottom) + 75px)' : '50px'};
    right: 55px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    ${CssRule.For.mobile.build()} & {
      right: 40px;
    }
    ${props => props.hasCircle? css`
    background-repeat: no-repeat;
    background-color: ${props => props.theme.colors.brandPrimary};
    border-radius: 50%;
    ` : '' }
`;